"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../");
var _styles = _interopRequireDefault(require("../styles"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _excluded = ["children", "disableTypography", "classes"];
var styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.h2.fontSize,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: theme.typography.h2.lineHeight,
      margin: 0,
      padding: 0,
      wordBreak: 'break-word'
    }
  };
};

/**
 * DialogTitle is the title within a Dialog.
 */
var DialogTitle = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
    disableTypography = props.disableTypography,
    classesProp = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classes = {
    root: classesProp.root
  };

  // use our own typography element (if the user hasn't disabled typography for titles),
  // so that we can control the variant
  var titleContents = disableTypography ? children : /*#__PURE__*/_react.default.createElement(_.Typography, {
    variant: "h2",
    component: "span"
  }, children);
  return /*#__PURE__*/_react.default.createElement(_DialogTitle.default, (0, _extends2.default)({
    classes: classes
  }, rest, {
    ref: ref
  }), titleContents);
});
DialogTitle.muiName = 'DialogTitle';
DialogTitle.displayName = 'DialogTitle';
DialogTitle.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes.default.bool
};
DialogTitle.defaultProps = {
  disableTypography: false
};
var _default = exports.default = (0, _styles.default)(styles)(DialogTitle);